import React from 'react'
import { useIntl } from 'react-intl'

import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Text,
  SpacingVertical,
  Flex,
  Button,
} from 'mailup-web-components'
import arrowRightBlu from 'Img/arrow-right-blu.svg'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { evalCondition, notifyParent } from 'mailup-react-helpers'
import { modalBrandShieldState } from './recoil/state'

const ModalBrandShield = (props) => {
  const intl = useIntl()

  const { show } = useRecoilValue(modalBrandShieldState)
  const close = useResetRecoilState(modalBrandShieldState)
  const showMshop = evalCondition(
    'NOT c:IsRetailer AND uo:GEST AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP',
  )
  const goToMshop = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshopproddet&cp=MUBRAND01',
    ])
  }
  return (
    <>
      <Modal show={show} onClose={close}>
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.UpsellBanner.BrandShieldModalTitle',
          })}
        />
        <ModalBody>
          <Text>
            {intl.formatMessage(
              {
                id: 'Load.UpsellBanner.BrandShieldModalBody',
              },
              {
                strong: (chunks) => <strong>{chunks}</strong>,
              },
            )}
          </Text>
          <SpacingVertical />
          <Text variant="bold">
            {intl.formatMessage({
              id: 'Load.UpsellBanner.BrandShieldModalIncludes',
            })}
          </Text>
          <SpacingVertical variant="8" />
          <Flex gap="8px">
            <img src={arrowRightBlu} alt={''} />
            <Text>
              {intl.formatMessage({
                id: 'Load.UpsellBanner.BrandShieldModalPlus1',
              })}
            </Text>
          </Flex>
          <SpacingVertical variant="4" />
          <Flex gap="8px">
            <img src={arrowRightBlu} alt={''} />
            <Text>
              {intl.formatMessage({
                id: 'Load.UpsellBanner.BrandShieldModalPlus2',
              })}
            </Text>
          </Flex>
        </ModalBody>
        <ModalFoot>
          <Button
            onClick={close}
            kind={showMshop ? 'secondary' : 'primary'}
            data-mu-test="mailupShield-closeModal"
          >
            {intl.formatMessage({
              id: 'Load.Common.Close',
            })}
          </Button>
          {showMshop && (
            <Button onClick={goToMshop} data-mu-test="modal-brandShield-buy">
              {intl.formatMessage({
                id: 'Load.UpsellBanner.BrandShieldModalBuyBtn',
              })}
            </Button>
          )}
        </ModalFoot>
      </Modal>
    </>
  )
}

export default ModalBrandShield
